
  import { mapActions, mapGetters } from 'vuex'

  import { ListingFilter, ListingFilterOption } from '@loavies/c2c-models'

  import IconCheckmarkBorderless from '@loavies/component-library/dist/icons/icon-checkmark-borderless'

  export default {
    components: {
      IconCheckmarkBorderless,
    },
    props: {
      filter: {
        type: ListingFilter,
        required: true,
      },
      filterOption: {
        type: ListingFilterOption,
        required: true,
      },
    },
    emits: ['click'],
    computed: {
      ...mapGetters({
        isActiveFilterOption: 'listings/isActiveFilterOption',
        getAvailableFilterOptionCount: 'listings/getAvailableFilterOptionCount',
      }),
      isActive() {
        return this.isActiveFilterOption(this.filter, this.filterOption)
      },
      filterCount() {
        return this.getAvailableFilterOptionCount(this.filter, this.filterOption)
      },
      translatedKey() {
        return this.$filtersTranslationService.getFilterOptionTranslation(this.filterOption)
      },
    },
    methods: {
      ...mapActions({
        addActiveFilterOption: 'listings/addActiveFilterOption',
        removeActiveFilterOption: 'listings/removeActiveFilterOption',
      }),
      toggleFilter() {
        if (this.isActive) {
          return this.removeFilterOption()
        }

        this.setFilterOption()
      },
      setFilterOption() {
        this.addActiveFilterOption({
          filter: this.filter,
          filterOption: this.filterOption,
        })
      },
      removeFilterOption() {
        this.removeActiveFilterOption({
          filter: this.filter,
          filterOption: this.filterOption,
        })
      },
    },
  }
